import { useEffect, useRef, useState } from "react";

export default function useCustomerSongs(searchSongs, enabled, query, page) {
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ items: [], total: 0, loading: false, error: "" });
  const cache = useRef(new Map());
  useEffect(() => {
    if (!enabled || !searchSongs) return undefined;
    const key = JSON.stringify([query.trim(), page]);
    const cached = cache.current.get(key);
    if (cached) {
      setState({ ...cached, loading: false, error: "" });
      return undefined;
    }
    const controller = new AbortController();
    let active = true;
    setState({ items: [], total: 0, loading: true, error: "" });
    const timer = setTimeout(async () => {
      try {
        const result = await searchSongs({ q: query.trim(), page, page_size: 10 }, controller.signal);
        if (active) {
          const value = { items: result.items, total: result.total };
          cache.current.set(key, value);
          setState({ ...value, loading: false, error: "" });
        }
      } catch (error) {
        if (active) setState({ items: [], total: 0, loading: false, error: error.response?.data?.message || "Chưa tải được bài hát. Vui lòng thử lại." });
      }
    }, query ? 300 : 0);
    return () => { active = false; clearTimeout(timer); controller.abort(); };
  }, [searchSongs, enabled, query, page, attempt]);
  return { ...state, retry: () => setAttempt((previous) => previous + 1) };
}
